import {
  adaptApiClients,
  adaptApiRetailers,
  type ApiClientConfig,
  type ApiRetailerConfig,
  type ClientOption,
  type RetailerOption,
} from "../config/retailerConfig";
import { buildApiUrl, getApiErrorMessage } from "./transport";

async function getJson<T>(endpoint: string): Promise<T> {
  const response = await fetch(buildApiUrl(endpoint));

  if (!response.ok) {
    throw new Error(await getApiErrorMessage(response));
  }

  return (await response.json()) as T;
}

export async function fetchRetailerConfig(): Promise<RetailerOption[]> {
  const payload = await getJson<ApiRetailerConfig[]>("/config/retailers");
  return adaptApiRetailers(payload);
}

export async function fetchClientConfig(): Promise<ClientOption[]> {
  const payload = await getJson<ApiClientConfig[]>("/config/clients");
  return adaptApiClients(payload);
}

export async function fetchUploadConfig(): Promise<{
  retailers: RetailerOption[];
  clients: ClientOption[];
}> {
  const [retailers, clients] = await Promise.all([
    fetchRetailerConfig(),
    fetchClientConfig(),
  ]);

  return { retailers, clients };
}
